
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { DateRecommendation, Guest } from "./types";
import { DateCard } from "./DateCard";

interface DateRecommendationListProps {
  recommendations: DateRecommendation[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  guests: Guest[];
}

export const DateRecommendationList = ({
  recommendations,
  selectedId,
  onSelect,
  guests
}: DateRecommendationListProps) => {
  // Sort recommendations by number of available guests in descending order
  const sortedRecommendations = [...recommendations].sort((a, b) => {
    const aAvailable = guests.filter(guest => guest.selected_dates?.includes(a.recommended_date)).length;
    const bAvailable = guests.filter(guest => guest.selected_dates?.includes(b.recommended_date)).length;
    return bAvailable - aAvailable; // Descending order
  });

  return (
    <div className="space-y-4 px-4">
      <h3 className="text-sm font-light">When</h3>
      <Carousel className="w-full overflow-visible">
        <CarouselContent className="py-2">
          {sortedRecommendations.map(rec => (
            <CarouselItem 
              key={rec.recommendation_id} 
              className="md:basis-1/2 lg:basis-1/3 basis-[85%] pr-4"
            >
              <DateCard 
                recommendation={rec} 
                isSelected={selectedId === rec.recommendation_id} 
                onClick={() => onSelect(rec.recommendation_id)} 
                guests={guests}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden md:flex -left-4" />
        <CarouselNext className="hidden md:flex -right-4" />
      </Carousel>
    </div>
  );
};
